import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getAdditionalSettings } from "@tLinc/Services/CustomAdditionalSettings";
import { CustomHandler } from "@tLinc/Store/CustomHandlerCreator/CustomHandlerCreator";
import { AdditionalSettingsModel } from "@tLinc/Store/Reducer/AdditionalSettingsReducer";

type Parameter = HasOnSuccess<AdditionalSettingsModel[]> & HasOnError<string>;

type Props = {
    apiResult: AdditionalSettingsModel;
};
type HandlerType = CustomHandler<Parameter, Props>;

export const LoadAdditionalSettings: HandlerType = async props => {
    props.apiResult = await getAdditionalSettings();
    props.dispatch({
        type: "Data/AdditionalSettings/LoadedAdditionalSettings",
        result: props.apiResult,
    });
};

export const chain = [LoadAdditionalSettings];

const loadAdditionalSettings = createHandlerChainRunner(chain, "LoadProducts");
export default loadAdditionalSettings;
